const clubHolder = [];

function clubsFromOrg(orgId) {
    const club = clubHolder[orgId];

    if (club) {
        return club;
    }

    return false;
}

/**
 * Organizations
 */
const organizations = [
    {
        // Yeah, I know.... I hate myself for that one
        id: '',
        name: '',
    },
    {
        id: 391,
        name: 'Eliteserien',
    },
    {
        id: 459,
        name: 'FotballMedia',
    },
    {
        id: 390,
        name: 'Mediapartnere',
    },
    {
        id: 532,
        name: 'NFF Landslag',
    },
    {
        id: 395,
        name: 'NFF Offisielle',
    },
    {
        id: 393,
        name: 'OBOS Ligaen',
    },
    {
        id: 635,
        name: 'PostNord Ligaen',
    },
    {
        id: 489,
        name: 'Produksjon',
    },
    {
        id: 394,
        name: 'Sponsorer',
    },
    {
        id: 392,
        name: 'Toppserien',
    },
];


/**
 * Mediapartnere
 */
clubHolder[390] = [
    {
        id: 485,
        name: '100% Sport',
    },
    {
        id: 401,
        name: 'Amedia',
    },
    {
        id: 396,
        name: 'Cmore',
    },
    {
        id: 486,
        name: 'Dagbladet',
    },
    {
        id: 481,
        name: 'Lokal-Avis',
    },
    {
        id: 400,
        name: 'Monday',
    },
    {
        id: 402,
        name: 'NRK',
    },
    {
        id: 398,
        name: 'Perform',
    },
    {
        id: 397,
        name: 'TV2',
    },
    {
        id: 399,
        name: 'VG',
    },
];

/**
 * Tippeligaen --> Eliteserien
 */
clubHolder[391] = [
    {
        id: 420,
        name: 'Brann',
    },
    {
        id: 414,
        name: 'Haugesund',
    },
    {
        id: 423,
        name: 'Kristiansund',
    },
    {
        id: 408,
        name: 'Lillestrøm',
    },
    {
        id: 403,
        name: 'Molde',
    },
    {
        id: 406,
        name: 'Odd',
    },

    {
        id: 404,
        name: 'Rosenborg',
    },
    {
        id: 417,
        name: 'Sandefjord Fotball',
    },
    {
        id: 411,
        name: 'Sarpsborg 08',
    },
    {
        id: 421,
        name: 'Sogndal',
    },
    {
        id: 412,
        name: 'Stabæk',
    },
    {
        id: 407,
        name: 'Strømsgodset',
    },
    {
        id: 418,
        name: 'Tromsø',
    },
    {
        id: 413,
        name: 'Viking',
    },
    {
        id: 409,
        name: 'Vålerenga',
    },

    {
        id: 410,
        name: 'Aalesund',
    },
];

/**
 * Toppserien
 */
clubHolder[392] = [
    {
        id: 438,
        name: 'Arna-Bjørnar',
    },
    {
        id: 440,
        name: 'Avaldsnes',
    },
    {
        id: 951,
        name: 'Grand Bodø',
    },
    {
        id: 443,
        name: 'Klepp',
    },
    {
        id: 439,
        name: 'Kolbotn',
    },
    {
        id: 436,
        name: 'LSK Kvinner',
    },
    {
        id: 444,
        name: 'Medkila',
    },

    {
        id: 441,
        name: 'Røa Fotball Elite',
    },
    {
        id: 446,
        name: 'Sandviken',
    },
    {
        id: 412,
        name: 'Stabæk',
    },
    {
        id: 442,
        name: 'Trondheims-Ørn',
    },
    /*
    {
    id: 577,
    name: 'Urædd',
    },*/
    {
        id: 409,
        name: 'Vålerenga',
    },
];

/**
 * OBOSligaen
 */
clubHolder[393] = [
    {
        id: 938,
        name: 'Arendal',
    },
    {
        id: 416,
        name: 'Bodø/Glimt',
    },
    /*
    {
        id: 428,
        name: 'Bryne',
    },*/
    {
        id: 935,
        name: 'Elverum',
    },
    {
        id: 942,
        name: 'Florø',
    },
    {
        id: 425,
        name: 'Fredrikstad',
    },
    /*
    {
        id: 427,
        name: 'Hødd',
    },*/
    {
        id: 432,
        name: 'Jerv',
    },
    /*
    {
        id: 574,
        name: 'KFUM',
    },*/
    {
        id: 576,
        name: 'Kongsvinger',
    },

    {
        id: 433,
        name: 'Levanger',
    },

    {
        id: 419,
        name: 'Mjøndalen',
    },
    {
        id: 426,
        name: 'Ranheim TF',
    },
    /*
    {
        id: 573,
        name: 'Raufoss',
    },*/
    {
        id: 422,
        name: 'Sandnes Ulf',
    },
    {
        id: 415,
        name: 'Start',
    },
    {
        id: 429,
        name: 'Strømmen',
    },
    {
        id: 950,
        name: 'Tromsdalen',
    },

    {
        id: 575,
        name: 'Ullensaker/Kisa',
    },
    {
        id: 434,
        name: 'Åsane',
    },
];

/**
 * Sponsorer
 */
clubHolder[394] = [
    {
        id: 1081,
        name: 'Altibox',
    },
    {
        id: 448,
        name: 'Bama',
    },
    {
        id: 553,
        name: 'Canal Digital',
    },
    {
        id: 451,
        name: 'Gjensidige',
    },
    {
        id: 452,
        name: 'Nike',
    },
    {
        id: 449,
        name: 'Norsk Tipping',
    },
    {
        id: 450,
        name: 'Statoil',
    },
    {
        id: 453,
        name: 'Thon Hotels',
    },
    {
        id: 447,
        name: 'Telenor',
    },
    {
        id: 399,
        name: 'VG',
    },
    {
        id: 454,
        name: 'P4',
    },
];

/**
 * NFF Offisielle
 */
clubHolder[395] = [
    {
        id: 373,
        name: 'Dommer',
    },
    {
        id: 455,
        name: 'Mediaoffiserer',
    },
    {
        id: 456,
        name: 'NFF-brukere',
    },
    {
        id: 552,
        name: 'Norsk Supporterallianse',
    },
];

/**
 * FotballMedia
 */
clubHolder[459] = [
    {
        id: 457,
        name: 'Fotball Media Admins',
    },
    {
        id: 257,
        name: 'Fotball Media Users',
    },
    {
        id: 458,
        name: 'UMC Redigerere',
    },
];

/**
 * Produksjon
 */
clubHolder[489] = [
    {
        id: 490,
        name: 'NEP Norway',
    },
    /*
    {
        id: 490,
        name: 'Mediatec Broadcast',
    },
    {
        id: 484,
        name: 'OB Team',
    },*/
    {
        id: 491,
        name: 'TVP Broadcast',
    },
];

/**
 * NFL Landslag
 */
clubHolder[532] = [
    {
        id: 533,
        name: 'A-menn',
    },

    {
        id: 534,
        name: 'A-kvinner',
    },
    {
        id: 541,
        name: 'J15',
    },
    {
        id: 539,
        name: 'J16/17',
    },
    {
        id: 537,
        name: 'J19',
    },
    {
        id: 540,
        name: 'G15',
    },
    {
        id: 538,
        name: 'G17',
    },
    {
        id: 536,
        name: 'G19',
    },
    {
        id: 535,
        name: 'G21',
    },
];

/**
 * Oddsenligaen
 */
clubHolder[572] = [
    {
        id: 424,
        name: 'Bærum',
    },
    {
        id: 435,
        name: 'Follo',
    },
    {
        id: 430,
        name: 'Hønefoss BK',
    },
    {
        id: 431,
        name: 'Nest-Sotra',
    },
];

/**
 * 1. Divisjon damer
 */
clubHolder[578] = [{
    id: 445,
    name: 'Amazon Grimstad',
}];

clubHolder[635] = [{
    id: 636,
    name: 'PostNord Ligaen - Alle klubber',
}];


module.exports = {
    organizations,
    clubsFromOrg,
};



// WEBPACK FOOTER //
// ./apps/registration/scripts/fotballmedia.js